import { actionCreator, persistentReducedStream, reducer } from 'rxbeach';
import { NotificationState } from './types';

export const showSuccessNotification = actionCreator<string>(
  '[notification] show success'
);
export const showErrorNotification = actionCreator<string>(
  '[notification] show error'
);
export const hideNotification = actionCreator('[notification] hide');

const showSuccess = reducer(
  showSuccessNotification,
  (_: NotificationState, success) => ({
    success,
  })
);

const showError = reducer(
  showErrorNotification,
  (_: NotificationState, error) => ({
    error,
  })
);

const hide = reducer(hideNotification, () => ({}));

export const notification$ = persistentReducedStream('notification', {}, [
  showSuccess,
  showError,
  hide,
]);
